<template>
  <div class="form" v-if="isReady">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
// Vuex
// https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
import { mapState } from 'vuex'
import { cloneDeep, get, isArray, isBoolean, isNumber, isString } from 'lodash'
import moment from 'moment'

export default {
  props: ['components'],
  name: 'Form',
  data() {
    return {
      isReady: false
    }
  },
  computed: {
    // The mapState Helper
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState({
      readOnly: state => state.config.readOnly,
      config: state => state.config,
      formDataId: state => state.formDataId.data,
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let after = ''
      if (vm.$route.path.indexOf('playground') !== -1) {
        after += '-playground'
      }

      if (vm.readOnly) {
        vm.$router.replace({
          name: 'read-only' + after,
          params: {
            components: vm.components
          }
        })
      } else {
        vm.$router.replace({
          name: 'edit' + after,
          params: {
            components: vm.components
          }
        })
      }
    })
  },
  methods: {
    setValue(component) {
      let type = component.type

      if(!component.data) {
        return
      }

      this.$set(component.data, 'currentValue', component.data.defaultValue)

      // Bind
      if (this.formDataId) {
        if (this.formDataId[component.key]) {
          component.data.currentValue = this.formDataId[component.key]
        }
      }

      // De-Para
      if (this.config.json) {
        if (!component.keyCustom) {
          component.keyCustom = 'json.' + component.key
        }

        let y
        let keyCustom = cloneDeep(component.keyCustom)
        let array = keyCustom.split('.')
        for (var i = 0; i < array.length; i++) {
          switch (array[i]) {
            case 'json':
              y = this.config.json
              break
            case 'formDataId':
              y = this.formDataId
              break
            default:
              let tmpY = get(y, array[i])
              if (!tmpY) {
                y = get(y, component.key)
                i = array.length
              } else {
                y = tmpY
              }
          }
        }

        if (['text', 'textarea', 'password', 'datepicker', 'help-block'].includes(type)) {
          if (isString(y)) {
            component.data.currentValue = y
          }
        } else if (['number'].includes(type)) {
          if (isNumber(y)) {
            component.data.currentValue = y
          }
        } else if (['checkbox', 'radio'].includes(type)) {
          if (isArray(y)) {
            component.data.currentValue = y
          }
        } else if (['checkbox-single'].includes(type)) {
          if (isBoolean(y)) {
            component.data.currentValue = y
          }
        } else if (type.includes('select')) {
          if (isArray(y)) {
            component.data.currentValue = y
          }
        }
      }

      if (component.type === 'datepicker') {
        component.data.currentValue = moment(component.data.currentValue, 'YYYY-MM-DD').format('DDMMYYYY')
      }

      this.$set(component.data, 'initialValue', component.data.currentValue)
    },
    updateComponentValues(components) {
      components.forEach((component) => {
        if (component.type === 'group') {
          this.updateComponentValues(component.components)
        } else {
          this.setValue(component)
        }
      })
    }
  },
  created() {
    this.isReady = false
    this.updateComponentValues(this.components)
    this.isReady = true
  }
}
</script>
